import { inject, Injector } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { resolveGraphqlEndpoint } from '../core/config/graphql-endpoint';
import { AuthService } from '../core/services/auth.service';

export function provideGraphqlClient() {
  return provideApollo(() => {
    const httpLink = inject(HttpLink);
    const injector = inject(Injector);
    const uri = resolveGraphqlEndpoint();
    const authLink = setContext(() => {
      // Resolve lazily per request to avoid Apollo <-> AuthService circular DI.
      const token = injector.get(AuthService).getAccessToken();
      const headers: Record<string, string> = {};

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      return { headers };
    });

    return {
      link: ApolloLink.from([authLink, httpLink.create({ uri })]),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'network-only',
        },
        query: {
          fetchPolicy: 'network-only',
        },
      },
    };
  });
}
